<template>
  <form-block
    :title="tr('Post type')"
    :description="description"
  >
    <template v-if="showFacebookBlock">
      <post-type-selector
        ref="facebookSelector"
        platform="facebook"
        :entity="entity"
        :disabled="disabled"
      />

      <info-text v-if="showEventInfo">
        {{ tr('Events can\'t be advertised directly, but if you share the event on your Facebook Page, you\'ll be able to boost that post.') }}
      </info-text>
      <info-text v-if="showUnknownInfo">
        {{ tr('For these posts the type of the content cannot be determined - shared posts, events and group posts typically end up here. They can only be advertised by boosting, no ad creative can be built from them.') }}
      </info-text>
    </template>

    <post-type-selector
      v-if="showInstagramBlock"
      ref="instagramSelector"
      platform="instagram"
      :entity="entity"
      :disabled="disabled"
    />

    <p v-if="!showFacebookBlock && !showInstagramBlock" class="m-0 text-muted-foreground">
      {{ tr('Please, select a source first.') }}
    </p>
  </form-block>
</template>

<script>
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import InfoText from '@/ui/components/InfoText.vue';
import PostTypeSelector from '@/ui/components/RuleForm/PostTypeSelector.vue';

export default {
  name: 'PostTypeBlock',
  components: {
    InfoText,
    PostTypeSelector,
  },
  mixins: [ RuleFormBlockMixin ],
  props: {
    description: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
  },
  computed: {
    showFacebookBlock() {
      return this.entity.hasSelectedFacebookPlatform;
    },
    showInstagramBlock() {
      return this.entity.hasSelectedInstagramPlatform;
    },
    showEventInfo() {
      return this.entity.facebook_post_media_types.includes('event');
    },
    showUnknownInfo() {
      return this.entity.facebook_post_media_types.includes('unknown');
    },
  },
  watch: {
    showFacebookBlock: {
      immediate: true,
      handler(val, oldVal) {
        if (oldVal === undefined) {
          return;
        }

        if (val) {
          if (this.entity.facebook_post_types.length == 0) {
            this.$nextTick(() => this.$refs.facebookSelector.selectAll());
          }
        }
        else {
          this.entity.facebook_post_types = [];
          this.entity.facebook_post_media_types = [];
        }
      },
    },
    showInstagramBlock: {
      immediate: true,
      handler(val, oldVal) {
        if (oldVal === undefined) {
          return;
        }

        if (val) {
          if (this.entity.instagram_post_types.length == 0) {
            this.$nextTick(() => this.$refs.instagramSelector.selectAll());
          }
        }
        else {
          this.entity.instagram_post_types = [];
          this.entity.instagram_post_media_types = [];
        }
      },
    },
  },
  methods: {
    validate() {
      if (this.showFacebookBlock) {
        if (this.entity.facebook_post_types.length === 0) {
          this.error(this.tr('At least one {platform} post type must be selected!', { '{platform}': 'Facebook' }));
          return false;
        }
        if (this.entity.facebook_post_media_types.length === 0) {
          this.error(this.tr('At least one {platform} post media type must be selected!', { '{platform}': 'Facebook' }));
          return false;
        }
      }

      if (this.showInstagramBlock) {
        if (this.entity.instagram_post_types.length === 0) {
          this.error(this.tr('At least one {platform} post type must be selected!', { '{platform}': 'Instagram' }));
          return false;
        }
        if (this.entity.instagram_post_media_types.length === 0) {
          this.error(this.tr('At least one {platform} post media type must be selected!', { '{platform}': 'Instagram' }));
          return false;
        }
      }

      return true;
    },
  },
};
</script>
